import { getStrDateLong, postgresDateToIndonesia } from "utils/MyUtils";

export function formatKegiatanDate(value) {
  return value ? postgresDateToIndonesia(value) || getStrDateLong(value) : "";
}
